import { Component, ViewEncapsulation } from '@angular/core';

import { ShareDialogComponent } from '@alfresco/adf-content-services';

@Component({
  selector: 'wk-share-document',
  templateUrl: './wk-share-document.component.html',
  styleUrls: ['./wk-share-document.component.scss'],
  host: { class: 'adf-share-dialog' },
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkShareDocumentComponent extends ShareDialogComponent {}
